import { render, staticRenderFns } from "./Carte.vue?vue&type=template&id=6bf627b2&scoped=true"
import script from "./Carte.vue?vue&type=script&lang=js"
export * from "./Carte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf627b2",
  null
  
)

export default component.exports